import Debug from 'bloko/common/core/Debug';

export default Debug;
